import React from 'react'
import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import { Icon } from '@chakra-ui/react'
import { FaExclamationTriangle, FaSync } from 'react-icons/fa'
import Header from '../../../Header'
import { ErrorStateProps } from '../types'

const ErrorState: React.FC<ErrorStateProps> = ({ 
  error, 
  isRetrying, 
  onRetry, 
  subtitle, 
  title 
}) => (
  <Box p={{ base: 2, md: 4 }}>
    <Header title={title} subtitle={subtitle} />
    
    <Flex 
      align="center" 
      bg="gray.800" 
      borderRadius="lg" 
      boxShadow="lg" 
      direction="column" 
      justify="center" 
      minHeight="300px" 
      p={8}
    >
      <Icon as={FaExclamationTriangle as any} color="red.400" h={12} mb={4} w={12} />
      
      <Heading as="h3" mb={2} size="md">
        Unable to Load Stock Data
      </Heading>
      
      <Text color="gray.400" mb={6} textAlign="center">
        {error}
      </Text>
      
      <Button
        colorScheme="blue"
        isLoading={isRetrying}
        leftIcon={<Icon as={FaSync as any} />}
        onClick={onRetry}
      >
        Retry
      </Button>
    </Flex>
  </Box>
)

export default ErrorState
